import styled from 'styled-components';

import { media } from '../../styles/constants';

const SmallCircle = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  .text {
    text-align: center;
    font-size: 2.2rem;
    line-height: 3rem;

    left: 50%;
    transform: translate(-50%, 0);

    @media (min-width: ${media.tabletPortrait}) {
      font-size: 3rem;
      line-height: 3.9rem;
    }

    @media (min-width: ${media.tabletLandscape}) {
      font-size: 3.4rem;
      line-height: 4.5rem;
    }
  }

  > div,
  .text {
    position: absolute;
    top: 7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16.3rem;
    width: 13.3rem;

    @media (min-width: ${media.tabletPortrait}) {
      left: 50%;
      transform: translate(-50%, 0);
      height: 17rem;
      width: 14rem;
      top: auto;
      bottom: 15rem;
    }

    @media (min-width: ${media.tabletLandscape}) {
      height: 21.4rem;
      width: 17.4rem;
      bottom: 11.5rem;
    }

    @media (min-width: ${media.desktop}) {
      bottom: 15rem;
    }
  }

  > div {
    img,
    svg {
      max-width: 15rem;
      max-height: 10rem;
    }

    @media (min-width: ${media.tabletPortrait}) {
      height: 17rem;
      width: 14rem;
      top: auto;
      bottom: 15rem;

      img,
      svg {
        margin-top: 1.5rem;
        max-width: 15rem;
        max-height: 10rem;
      }
    }

    @media (min-width: ${media.tabletLandscape}) {
      height: 21.4rem;
      width: 17.4rem;
      bottom: 11.5rem;
    }

    @media (min-width: ${media.desktop}) {
      bottom: 15rem;

      img,
      svg {
        padding-bottom: 1.5rem;
      }
    }
  }

  /* Circle */
  svg {
    top: 30%;

    @media (min-width: ${media.tabletPortrait}) {
      top: 45%;
    }
  }
`;

export default SmallCircle;
